<loader *ngIf="showLoader"></loader>
<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <div class="card">
            <div class="card-body lounge-access-container">
                <div class="row m-0">
                    <div class="col-12">
                        <h4 class="textBlue ">Buy Lounge Access</h4>
                    </div>
                </div>
                <div class="row m-0">
                    <div class="col-12 col-md-5">
                        <div class="row">
                            <div class="col-12">
                                <div class="card">
                                    <div class="card-body product-info-box">
                                        <div class="row">
                                            <div class="col-12 col-md-12 product-details">
                                                <div class="row m-0">
                                                    <div class="col-12 col-md-6">
                                                        <h5 class="textBlue">Lounge Access</h5>
                                                        <p class="fs-10 m-0">{{ selectedLounge?.outletName }}</p>
                                                    </div>
                                                    <div class="col-12 col-md-6 text-right">
                                                        <p>
                                                            <s class="old-price">₹ {{ selectedLounge?.basePrice }} </s> 
                                                            <strong class="new-price fs-18">₹ {{ selectedLounge?.salePrice }}</strong>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-12 lounge-access-benefits">
                                                <div class="row m-0">
                                                    <div class="col-12 col-md-4 pl-0 text-left">Premium Facilities</div>
                                                    <div class="col-12 col-md-4 pl-0 text-left text-md-center">Free WiFi</div>
                                                    <div class="col-12 col-md-4 pl-0 pr-0 text-left text-md-right">Complimentary Food</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="card">
                                    <div class="card-body product-amount-breakup">
                                        <div class="row">
                                            <div class="col-12 col-md-12 bill-breakup">
                                                <div class="row m-0">
                                                    <div class="col-6 col-md-6">
                                                        <p class="">Amount</p>
                                                    </div>
                                                    <div class="col-6 col-md-6 text-right">
                                                        <p class="">{{ selectedLounge?.salePrice }}</p>
                                                    </div>
                                                </div>
                                                <div class="row m-0">
                                                    <div class="col-6 col-md-6">
                                                        <p class="textBlue">Taxes</p>
                                                    </div>
                                                    <div class="col-6 col-md-6 text-right">
                                                        <p class="textBlue">{{ selectedLounge?.gst }}</p>
                                                    </div>
                                                </div>
                                                <!-- <div class="row m-0 discount">
                                                    <div class="col-6 col-md-6">
                                                        <p class="textBlue">Discount</p>
                                                    </div>
                                                    <div class="col-6 col-md-6 text-right">
                                                        <p class="textBlue">-₹200</p>
                                                    </div>
                                                </div> -->
                                                <hr />
                                                <div class="row m-0 total-amount">
                                                    <div class="col-6 col-md-6">
                                                        <p class="textBlue">Total Price</p>
                                                    </div>
                                                    <div class="col-6 col-md-6 text-right">
                                                        <p class="textBlue">{{ selectedLounge?.payableAmount }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                        </div>
    
                    </div>
                    <div class="col-1 d-flex justify-content-center">
                        <div class="section-line"></div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="row">
                            <div class="col-12">
                                <p class="textBlue"><b>Payment Method</b></p>
                            </div>
                            <div class="col-12">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input fs-11" type="radio" name="payment" [(ngModel)]="paymentMode" id="netBanking" value="NB">
                                    <label class="form-check-label fs-11" for="netBanking">Net Banking</label>
                                </div>
                                <!-- <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="payment" [(ngModel)]="paymentMode" id="neft" value="NEFT" disabled>
                                    <label class="form-check-label" for="neft">NEFT/RTGS/IMPS</label>
                                </div> -->
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="payment" [(ngModel)]="paymentMode" id="upi" value="UPI">
                                    <label class="form-check-label" for="upi">UPI</label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 mb-30 mt-30 d-flex align-items-center p-0">
                                <div class="col-md-6 col-sm-6 d-flex justify-content-start align-items-center">
                                    <div class="fs-12 text-black fw-600">
                                        Choose Your Bank Account
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6 d-flex justify-content-end   mt-md-0">
                                    <button type="button" class="btn btn-primary btn-prev fs-12" rippleEffect
                                    (click)="openModalForAddBankAccount(addBankAccountModal)" style="font-size: 10px !important;color: black">Add Bank
                                        Account</button>
                    
                                </div>
                            </div>
                        </div>
                    
                        <div class="row">
                            <div class="col-md-12 mb-20" *ngFor="let singleBank of bankAccountList; let i = index">
                                <div [ngClass]="(bankAccountList.length - 1) == i ? 'border-bottom-white' : 'border-bottom-grey' ">
                                    <div class="row mb-10">
                    
                                        <div class="col-md-11 col-10">
                                            <input type="radio" name="radios" id="radio"
                                                (change)="getSelectedBankAccountID(singleBank.id)" />
                                            <span class="card-title fs-11 text-black fw-600 mb-10">
                                                {{singleBank.bankName}}
                                            </span>
                                            <div class="fs-11 ml-15"> Account No : {{singleBank.number}}</div>
                                            <div class="fs-11 ml-15"> IFSC Code : {{singleBank.ifscCode}}</div>
                                            <div class="fs-11 ml-15"> Branch : {{singleBank.branch}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    
                            <!-- <div class="col-md-4 col-12 mt-20">
                                                                                    <button type="button" class="btn btn-primary btn-prev fs-12" rippleEffect (click)="showAddBankForm = true">
                                                                                        Add Bank Account
                                                                                    </button>
                                                                                </div> -->
                        </div>
                    
                    
                    
                    </div>
                </div>
                <div class="row m-0">
                    <div class="col-6 text-left">
                        <button type="button" class="btn btn-outline-primary" (click)="goToLoungeListPage()">Back</button>
                    </div>
                    <div class="col-6 text-right">
                        <button type="button" class="btn btn-primary" (click)="placeLoungeAccessOrder()">Proceed</button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div><ng-template let-modal #addBankAccountModal>
    <div class="modal-header">
        <h6 class="modal-title" id="myModalLabel1"></h6>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <form class="form-horizontal" (ngSubmit)="addBankAccount(AddBankAccount.form.valid)" #AddBankAccount="ngForm">
            <div class="col-md-12">
                <loader *ngIf="showLoader"></loader>
                <div class="row mt-15">
                    <div class="form-group col-md-6">
                        <label class="form-label">Name</label>
                        <input required type="text" class="form-control fs-12" placeholder="Name" [(ngModel)]="addBankAccountRequest.nameAsPerAccountNumber" name="name" #nameRef="ngModel" [class.error]="AddBankAccount.submitted && nameRef.invalid" (keypress)="alphaNumberOnly($event)"
                            (paste)="onPaste($event)" maxlength="100" required />
                        <span *ngIf="AddBankAccount.submitted && nameRef.invalid" class="invalid-form">
                            <small class="form-text text-danger" *ngIf="nameRef.errors.required">This field is required!</small>
                        </span>
                    </div>
                    <div class="form-group col-md-6">
                        <label class="form-label" for="country">Relationship*</label>
                        <ng-select class="fs-12" [items]="bankRelationshipList" bindValue="bankRelationshipList" [(ngModel)]="addBankAccountRequest.relation" required placeholder="Relationship" name="relationship" #relationshipRef="ngModel" [class.error]="AddBankAccount.submitted && relationshipRef.invalid"
                            [clearable]="false" [searchable]="true">
                        </ng-select>
                        <span *ngIf="AddBankAccount.submitted && relationshipRef.invalid" class="invalid-form">
                            <small class="form-text text-danger" *ngIf="relationshipRef.errors.required">This field is required!</small>
                        </span>
                    </div>
                </div>

                <div class="row mt-15">
                    <div class="form-group col-md-6">
                        <label class="form-label" for="country">Bank Name*</label>
                        <ng-select [items]="bankDropdownItemList" bindLabel="displayName" bindValue="displayName" [(ngModel)]="addBankAccountRequest.bankName" placeholder="Select" name="bank_name" #bankNameRef="ngModel" [class.error]="AddBankAccount.submitted && bankNameRef.invalid"
                            [searchable]="false" required>
                        </ng-select>
                        <span *ngIf="AddBankAccount.submitted && bankNameRef.invalid" class="invalid-form">
                            <small class="form-text text-danger" *ngIf="bankNameRef.errors.required">This field is required!</small>
                        </span>
                    </div>
                    <div class="form-group col-md-6">
                        <label class="form-label">Branch Name</label>
                        <input type="text" class="form-control fs-12" name="ifscCode" placeholder="Branch Name" maxlength="100" [(ngModel)]="addBankAccountRequest.branch" #branchNameRef="ngModel" [class.error]="AddBankAccount.submitted && branchNameRef.invalid" required />
                        <span *ngIf="AddBankAccount.submitted && branchNameRef.invalid" class="invalid-form">
                            <small class="text-danger" *ngIf="branchNameRef.errors.required">This field is required!</small>
                        </span>
                    </div>
                </div>
                <div class="row mt-15">
                    <div class="form-group col-md-6">
                        <label class="form-label">Account Number</label>
                        <div class="input-group form-password-toggle">
                            <input [type]="showAccountNo ? 'text' : 'password'" class="form-control fs-12" [(ngModel)]="addBankAccountRequest.number" placeholder="Account Number" name="account_no" #accountNoRef="ngModel" [class.error]="AddBankAccount.submitted && accountNoRef.invalid"
                                (keypress)="keyPressNumbers($event)" (paste)="onPaste($event)" maxlength="30" required autoComplete="true" />
                            <div class="input-group-append" (click)="showAccountNo = !showAccountNo">
                                <span class="input-group-text cursor-pointer" style="height:38px !important"><i class="feather"
                                [ngClass]="{'icon-eye-solid': showAccountNo, 'icon-eye-slash-solid': !showAccountNo }"></i></span>
                            </div>

                        </div>
                        <!-- <input required type="password" class="form-control fs-12" placeholder="Account Number" [(ngModel)]="addBankAccountRequest.number" name="account_no" #accountNoRef="ngModel" [class.error]="AddBankAccount.submitted && accountNoRef.invalid" required /> -->
                        <span *ngIf="AddBankAccount.submitted && accountNoRef.invalid" class="invalid-form">
                            <small class="form-text text-danger" *ngIf="accountNoRef.errors.required">This field is required!</small>
                        </span>
                    </div>
                    <div class="form-group col-md-6">
                        <label class="form-label">Confirm Account Number</label>
                        <input required type="text" name="confirm_acccount_no" class="form-control fs-12" placeholder="Confirm Account Number" [(ngModel)]="addBankAccountRequest.confirmAccNo" #confirmAccountNoRef="ngModel" [class.error]="AddBankAccount.submitted && confirmAccountNoRef.invalid"
                            (keypress)="keyPressNumbers($event)" (paste)="onPaste($event)" maxlength="30" required autoComplete="true" />
                        <span *ngIf="AddBankAccount.submitted && confirmAccountNoRef.invalid" class="invalid-form">
                            <small class="form-text text-danger" *ngIf="confirmAccountNoRef.errors.required">This field is required!</small>
                        </span>
                    </div>
                </div>

                <div class="row mt-15">

                    <div class="form-group col-md-6">
                        <label class="form-label">IFSC Number</label>
                        <input type="text" class="form-control fs-12" name="ifscCode" placeholder="IFSC Number" [(ngModel)]="addBankAccountRequest.ifscCode" #ifscCodeRef="ngModel" [class.error]="AddBankAccount.submitted && ifscCodeRef.invalid" required pattern="([A-Za-z0]{4})(0\d{6})$"
                            (keypress)="alphaNumberOnly($event)" (paste)="onPaste($event)" maxlength="11" />
                        <span *ngIf="AddBankAccount.submitted && ifscCodeRef.invalid" class="invalid-form">
                            <small class="text-danger" *ngIf="ifscCodeRef.errors.required">This field is required!</small>
                        </span>
                        <div class="text-danger fs-11" *ngIf="AddBankAccount.submitted && ifscCodeRef.invalid">IFSC Code must be in valid format!</div>
                    </div>
                </div>

                <div class="row">
                    <button class="col-md-2 offset-md-5 btn btn-primary fw-500 fs-12 text-center blue-text" type="submit" style="cursor: pointer;">
                        Add
                    </button>
                </div>
            </div>
        </form>
    </div>
</ng-template>